export const timesWidgetDefaults = [
  {
    uId: '9d5a8df9-9463-46be-8238-c95a999a6795',
    code: 'USA-CA',
    name: 'San Francisco, CA',
    timezone: 'America/Los_Angeles',
    alpha2CountryCode: 'US',
    focusPoint: {
      latitude: 37.7749,
      longitude: -122.4194,
      zoomLevel: 12
    },
    place: {
      locality: 'San Francisco',
      area: 'CA',
      country: 'USA',
      displayName: 'San Francisco, CA USA'
    }
  },
  {
    uId: '6b298396-d1e6-41e7-94cc-c76d2b079528',
    code: 'USA-IL',
    name: 'Chicago, IL',
    timezone: 'America/Chicago',
    alpha2CountryCode: 'US',
    focusPoint: {
      latitude: 41.8781,
      longitude: -87.6298,
      zoomLevel: 12
    },
    place: {
      locality: 'Chicago',
      area: 'IL',
      country: 'USA',
      displayName: 'Chicago, IL USA'
    }
  },
  {
    uId: '27e44998-1032-45fe-bab4-31bf3e3a9531',
    code: 'USA-NY',
    name: 'New York City, NY',
    timezone: 'America/New_York',
    alpha2CountryCode: 'US',
    focusPoint: {
      latitude: 40.7128,
      longitude: -74.006,
      zoomLevel: 12
    },
    place: {
      locality: 'New York City',
      area: 'NY',
      country: 'US',
      displayName: 'New York City, NY USA'
    }
  },
  {
    uId: '44ce38e1-b754-4118-b606-59cf6b5f5dd1',
    code: 'UK',
    name: 'London',
    timezone: 'Europe/London',
    alpha2CountryCode: 'GB',
    focusPoint: {
      latitude: 51.5272,
      longitude: -0.0776,
      zoomLevel: 12
    },
    place: {
      locality: 'London',
      area: null,
      country: 'UK',
      displayName: 'London, UK'
    }
  },
  {
    uId: '75a36dc9-cc15-4bcf-9df2-5675361082f6',
    code: 'TR',
    name: 'Istanbul',
    timezone: 'Europe/Istanbul',
    alpha2CountryCode: 'TR',
    focusPoint: {
      latitude: 41.015137,
      longitude: 28.97953,
      zoomLevel: 12
    },
    place: {
      locality: 'Istanbul',
      area: null,
      country: 'TR',
      displayName: 'Istanbul, TR'
    }
  },
  {
    uId: 'd4e424b6-1253-4359-80e2-d60c639b09cb',
    code: 'AU',
    name: 'Sydney',
    timezone: 'Australia/Sydney',
    alpha2CountryCode: 'AU',
    focusPoint: {
      latitude: -33.865143,
      longitude: 151.2099,
      zoomLevel: 12
    },
    place: {
      locality: 'Sydney',
      area: null,
      country: 'AU',
      displayName: 'Sydney, AU'
    }
  }
];